import React, { useState } from 'react';
import { PartnerGuard } from '../../../guards/RolesGuard';
import ExecutiveTab from './tabs/ExecutiveTab';
import DetailedTab from './tabs/DetailedTab';
import AdminTab from './tabs/AdminTab';

const InsightsTabs = [
    { name: 'Executive Dashboard', element: <ExecutiveTab /> },
    { name: 'Detailed View', element: <DetailedTab /> },
];

const InsightsTabsAdmin = [
    { name: 'Admin Dashboard', element: <AdminTab /> },
    { name: 'Executive Dashboard', element: <ExecutiveTab /> },
    { name: 'Detailed View', element: <DetailedTab /> },
];

const Homepage = () => {
    const tabs = PartnerGuard() ? InsightsTabsAdmin : InsightsTabs;
    const [activeTab, setActiveTab] = useState(tabs[0]);
    // const [displayedTab, setDisplayedTab] = useState(tabs[0]);
    const [isFading, setIsFading] = useState(false);

    const onClickTab = (tab: any) => {
        if (tab.name === activeTab.name) return;
        setIsFading(true);
        setTimeout(() => {
            setActiveTab(tab);
            // setDisplayedTab(tab);
            setIsFading(false);
        }, 300);
    };

    return (
        <div>
            <div className="bg-white dark:bg-bgColor-darkMode">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center">
                    <div className="my-5 rounded-xl md:rounded-full w-full md:w-auto bg-[#1E4380] dark:bg-black flex flex-col md:flex-row items-center px-2 py-2 md:px-1 md:py-1">
                        {tabs.map((item, idx) => (
                            <div
                                key={item.name}
                                onClick={() => onClickTab(item)}
                                className={`px-3 cursor-pointer w-[99%] md:w-auto m-auto text-center mb-2 md:mb-0 hover:opacity-90 ${activeTab?.name === item?.name
                                    ? 'bg-white dark:bg-bgColor-darkMode text-black dark:text-white rounded-lg md:rounded-full'
                                    : 'text-white dark:text-gray-600'
                                    } ${idx === 0 || (PartnerGuard() && idx !== 2) ? 'mr-2' : ''}`}
                            >
                                <p>{item?.name}</p>
                            </div>
                        ))}
                    </div>
                    <div>
                        <p className='text-primary-light dark:text-primary-dark font-bold'>Property: Lisbon</p>
                    </div>
                </div>
                <div className={`transition-opacity duration-300 ${isFading ? 'opacity-0' : 'opacity-100'}`}>
                    {/* {React.cloneElement(displayedTab?.element, {
						setActiveTabMain: setActiveTab
					})} */}

					{React.cloneElement(activeTab.element, {
						setActiveTabMain: setActiveTab
					})}
                </div>
            </div>
        </div>
    );
};

export default Homepage;
